"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationTriggerUpsert = exports.CommunicationTriggerUpdate = exports.CommunicationTriggerCreate = exports.CommunicationTrigger = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const common_types_1 = require("./common-types");
exports.CommunicationTrigger = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    sendGridID: typebox_1.Type.String(),
    onStatus: common_types_1.ServiceOrderStatus,
    active: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    sendsTo: common_types_1.SendsToTarget,
    metadata: common_1.MetaData,
});
exports.CommunicationTriggerCreate = typebox_1.Type.Omit(exports.CommunicationTrigger, ['id', 'metadata']);
exports.CommunicationTriggerUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.CommunicationTrigger, ['id', 'metadata']));
exports.CommunicationTriggerUpsert = typebox_1.Type.Intersect([
    exports.CommunicationTriggerCreate,
    typebox_1.Type.Object({
        id: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    }),
]);
//# sourceMappingURL=CommunicationTrigger.js.map